import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { Fonts } from "src/com/sixdee/crbtportal/utils/resources/fonts";
import { SearchBoxRadioCSSStyleImpl } from "../../../toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxradiocss";

export class BuyToneCheckboxCSSStyleImpl extends  SearchBoxRadioCSSStyleImpl
{
    getWrapperCSSStyle(): object
    {
      return {
          display: "flex",
          flexFlow: "row wrap",
      };
    }

    getCSSStyleOne():Object
    {
        return {
            position: 'relative', 
            height: '14px', 
            width: "14px",
            float: "left",
            marginTop: "2px",
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_2), 
            borderRadius: '14px'
        };
    }
    getCSSStyleTwo():Object
    {
        return {
            position: 'absolute', height: '4px', 
            width: '8px', top: '4px', left: '3px', 
            borderLeft: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderBottom: 'solid 2px '+ this.getResources().getColor(Colors.color_5), 
            borderRadius: '0px', 
            cursor: "pointer",
            transform: 'rotate(-45deg)'
        };
    }

    getCSSStyleThree():Object
    {
        return {
            position: 'relative', 
            height: '14px', 
            width: "14px",
            borderRadius: '14px', 
            float: "left",
            marginTop: "2px",
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "solid 1px" + this.getResources().getColor(Colors.color_8)
        };
    }

    getSelectedTextCSSStyle(): object 
    {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_7),
            height: "18px",
            fontWeight: 500,
            letterSpacing: 0,
            paddingLeft: "10px",
            paddingRight: "40px",
            lineHeight: "18px",
            outline: "none"
        };
    }
    getUnSelectedTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_38),
            height: "18px",
            fontWeight: 500,
            letterSpacing: 0,
            paddingLeft: "10px",
            paddingRight: "40px",
            lineHeight: "18px",
            outline: "none"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/buytone/buytonecheckboxcss.tsx